import { render, staticRenderFns } from "./BuiltWithAmcharts.vue?vue&type=template&id=0fe51a7e&scoped=true"
import script from "./BuiltWithAmcharts.vue?vue&type=script&lang=js"
export * from "./BuiltWithAmcharts.vue?vue&type=script&lang=js"
import style0 from "./BuiltWithAmcharts.vue?vue&type=style&index=0&id=0fe51a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe51a7e",
  null
  
)

export default component.exports